import * as React from 'react'

import { observer } from 'mobx-react'

import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  onClick: () => void
}

function NewRuleButton({ onClick }: IProps) {
  return (
    <span
      className="pointer text large blue-highlight ml20 no-flex"
      onClick={onClick}
    >
      + {Localization.translator.newRule}
    </span>
  )
}

export default observer(NewRuleButton)
